import React from 'react';
import {
    Paper,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Avatar,
    Checkbox,
    TextField,
    Typography,
    Chip,
    Tooltip,
    withStyles,
} from '@material-ui/core';

import styles from './styles';

function FaltasJ1Table({
    classes,
    membros,
    registros,
    processando,
    dtEvento,
    totaisFaltas,
    ano,
    onToggleFalta,
    onJustificativaChange,
    onJustificativaBlur,
    onVerHistorico,
}) {
    const getRegistro = idMembro =>
        registros.find(r => r.idMembro === idMembro);

    const getTotalFaltas = idMembro =>
        (totaisFaltas && totaisFaltas.get(idMembro)) || 0;

    return (
        <Paper>
            <div className={classes.header}>
                <Typography variant="h5">CONTROLE DE FALTAS</Typography>
                <Typography component="p" className={classes.meet}>
                    Marque quem faltou e informe a justificativa.
                </Typography>
            </div>

            {!dtEvento ? (
                <Typography component="p" className={classes.vazio}>
                    Selecione a data para registrar as faltas.
                </Typography>
            ) : membros.length === 0 ? (
                <Typography component="p" className={classes.vazio}>
                    Nenhum membro encontrado neste grupo.
                </Typography>
            ) : (
                <Table className={classes.table} aria-label="tabela de faltas">
                    <TableHead>
                        <TableRow>
                            <TableCell style={{ width: '10px' }} />
                            <TableCell>Nome</TableCell>
                            <TableCell align="center">
                                {`Faltas (${ano})`}
                            </TableCell>
                            <TableCell align="center">Faltou</TableCell>
                            <TableCell>Justificativa</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {membros.map(row => {
                            const registro = getRegistro(row.idMembro);
                            const faltou = !!registro;
                            const processandoMembro = !!processando.get(
                                row.idMembro
                            );

                            return (
                                <TableRow hover key={row.idMembro}>
                                    <TableCell>
                                        <Avatar
                                            className={classes.large}
                                            src={row.txFotoUrl}
                                        />
                                    </TableCell>
                                    <TableCell
                                        className={classes.tableCellNome}
                                        scope="row"
                                        align="left"
                                    >
                                        <span translate="no">
                                            {row.txMembro}
                                        </span>
                                    </TableCell>
                                    <TableCell align="center">
                                        <Tooltip title="Ver faltas do ano">
                                            <Chip
                                                label={getTotalFaltas(
                                                    row.idMembro
                                                )}
                                                clickable
                                                color={
                                                    getTotalFaltas(
                                                        row.idMembro
                                                    ) > 0
                                                        ? 'primary'
                                                        : 'default'
                                                }
                                                onClick={() =>
                                                    onVerHistorico(row.idMembro)
                                                }
                                            />
                                        </Tooltip>
                                    </TableCell>
                                    <TableCell align="center">
                                        <Checkbox
                                            color="primary"
                                            checked={faltou}
                                            disabled={processandoMembro}
                                            onChange={() =>
                                                onToggleFalta(row.idMembro)
                                            }
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <TextField
                                            className={classes.justificativa}
                                            placeholder="Justificativa (opcional)"
                                            multiline
                                            fullWidth
                                            disabled={!faltou}
                                            value={
                                                registro
                                                    ? registro.txJustificativa ||
                                                      ''
                                                    : ''
                                            }
                                            onChange={e =>
                                                onJustificativaChange(
                                                    row.idMembro,
                                                    e.target.value
                                                )
                                            }
                                            onBlur={() =>
                                                onJustificativaBlur(row.idMembro)
                                            }
                                        />
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            )}
        </Paper>
    );
}

export default withStyles(styles)(FaltasJ1Table);
